module.exports = __webpack_public_path__ + "static/img/江苏银行@2x.ba373934.png";